// Interface settings — the panel-dock layout. v1 holds one control: the
// per-player reset (drag/dock/resize all live on the panels themselves).

import { Button } from '@aod/ui/components/ui/button';
import { useT } from '../../i18n/index.js';
import { appDom } from '../../lib/appDom.js';
import { usePanelLayout } from '../../ui/layout/usePanelLayout.js';

export function InterfaceTab() {
  const t = useT();
  const reset = usePanelLayout((s) => s.reset);
  return (
    <div data-testid="settings-interface-tab">
      <h3 className="mb-4 text-sm font-medium text-foreground">{t('settings.tab.interface')}</h3>
      <p className="mb-4 text-xs leading-relaxed text-muted-foreground">
        {t('settings.layout.description')}
      </p>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        onClick={reset}
        data-testid="settings-layout-reset"
        {...appDom({
          id: 'settings-layout-reset',
          type: 'Button',
          role: 'button',
          scope: 'dialog',
        })}
        className="cursor-pointer text-xs"
      >
        {t('settings.layout.reset')}
      </Button>
    </div>
  );
}
